import { useNavigate } from 'react-router';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Alert from 'react-bootstrap/Alert';
import Badge from 'react-bootstrap/Badge';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import BSTooltip from 'react-bootstrap/Tooltip';
import Spinner from 'react-bootstrap/Spinner';

import Header from '../components/Header';
import Footer from '../components/Footer';
import { CsvFileDownloadBtn } from '../components/CsvFileDownloadBtn';
import { QRCodeDownloadBtn } from '../components/QRCodeDownloadBtn';

import { fetchToken } from '../components/Auth';
import { useGetApi } from '../components/ApiAccess';
import { getSelfClient } from '../components/ApiAccess';
import { ClientName } from '../components/ApiAccess';
import { formatErrorMessage } from '../components/FormatErrorMassage';

export default function CreateUnit({ mode }) {
  const navigate = useNavigate();
  const params = useParams();

  const {
    register,
    watch,
    handleSubmit,
    reset,
    formState: { isDirty, errors },
  } = useForm();

  const [errorResult, setErrorResult] = useState('');

  const [chooseFileName, setChooseFileName] = useState();

  const [clientId, setClientId] = useState();

  const [clientName, setClientName] = useState();

  const getClient = useGetApi('/api/v1/clients/' + params.clientId + '/');

  const [isSubmit, setIsSubmit] = useState(false);

  const spinner = () => {
    return (
      <>
        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"></Spinner>
        <span className="visually-hidden">登録中...</span>
      </>
    );
  };

  const [submitValue, setSubmitValue] = useState('登録する');

  const [unitId, setUnitId] = useState();

  const dateFormatter = (date) => {
    if (!date) {
      date = new Date();
    }
    const y = date.getFullYear();
    const m = ('00' + (date.getMonth() + 1)).slice(-2);
    const d = ('00' + date.getDate()).slice(-2);
    return y + '-' + m + '-' + d;
  };

  useEffect(() => {
    if (!clientId) {
      if (params.clientId) {
        setClientId(params.clientId);
      } else {
        getSelfClient().then((response) => {
          setClientId(response.data.id);
        });
      }
    }

    const subscription = watch((value, { name, type }) => {
      if (name === 'fileb') {
        if (value.fileb.length > 0) {
          setChooseFileName(value.fileb[0].name);
        } else {
          setChooseFileName('');
        }
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const regist = (data) => {
    const headers = {
      'Content-Type': 'multipart/form-data',
      Authorization: 'Bearer ' + fetchToken(),
    };

    const postData = new FormData();

    let scopeStart = null;
    let scopeEnd = null;
    if (data.scopeStart) {
      scopeStart = data.scopeStart;
    }
    if (data.scopeEnd) {
      scopeEnd = data.scopeEnd;
    }

    const unitNameJson = JSON.stringify({
      name: data.unitName,
      scope_start: scopeStart,
      scope_end: scopeEnd,
    });
    const blob = new Blob([unitNameJson], {
      type: 'application/json',
    });
    postData.append('unit', unitNameJson);
    postData.append('fileb', data.fileb[0]);

    setSubmitValue(spinner());

    axios
      .post('/api/v1/clients/' + clientId + '/units/', postData, { headers: headers })
      .then((response) => {
        setSubmitValue('登録する');
        setErrorResult();
        setIsSubmit(true);
        setUnitId(response.data.id);
        // downloadQRCode(response.data);
        navigate('/clients/' + clientId + '/units/' + response.data.id + '/edit', {
          state: { isCreate: true },
        });
      })
      .catch((error) => {
        reset({ fileb: '' });
        setChooseFileName('');
        const newErrorResult = formatErrorMessage(error.response?.data);
        setErrorResult(newErrorResult);
        setSubmitValue('登録する');
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 0);
      });
  };

  return (
    <div className="create-unit">
      <Header></Header>
      <main>
        <Container>
          <h2>施策登録</h2>
          {errorResult && (
            <Alert key={'danger'} variant={'danger'} className="create-unit-wordwrap">
              エラー:
              <br />
              {errorResult.map((htmlString, index) => (
                <React.Fragment key={index}>
                  {htmlString}
                  <br />
                </React.Fragment>
              ))}
            </Alert>
          )}
          <div className={'form-wrapper'}>
            <Form noValidate onSubmit={handleSubmit(regist)}>
              <Form.Group className="mb-4">
                <Form.Label className="h5">企業</Form.Label>
                <ClientName as={Form.Control} clientId={clientId} plaintext readOnly />
              </Form.Group>
              <Form.Group className="mb-4" controlId="unitName">
                <Form.Label className="h5">
                  施策名{' '}
                  <Badge bg="danger" className="ms-2">
                    必須
                  </Badge>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder=""
                  isInvalid={!!errors.unitName}
                  {...register('unitName', { required: true })}
                />
                {errors.unitName && (
                  <Form.Control.Feedback type="invalid">入力が必須の項目です</Form.Control.Feedback>
                )}
              </Form.Group>
              <Form.Group className="mb-4">
                <Form.Label className="h5">施策期間</Form.Label>
                <Row>
                  <Col>
                    <Form.Control type="date" {...register('scopeStart', { required: false })} />
                  </Col>
                  <Col xs="auto" className="py-2">
                    から
                  </Col>
                  <Col>
                    <Form.Control
                      type="date"
                      isInvalid={!!errors.scopeEnd}
                      {...register('scopeEnd', {
                        required: false,
                        validate: (value) => {
                          // 開始日の入力がないとき、終了日は今日以降の日付でなければならない
                          if (
                            watch('scopeStart') === '' &&
                            value !== '' &&
                            dateFormatter() > value
                          ) {
                            return '今日より後の日付を入力してください';
                            // 開始日の入力があるとき、終了日は開始日以降の日付でなければならない
                          } else if (
                            watch('scopeStart') !== '' &&
                            value !== '' &&
                            watch('scopeStart') > value
                          ) {
                            return '開始日より後の日付を入力してください';
                          }
                        },
                      })}
                    />
                    {errors.scopeEnd && (
                      <Form.Control.Feedback type="invalid">
                        <ErrorMessage
                          errors={errors}
                          name="scopeEnd"
                          render={({ message }) => <p>{message}</p>}
                        />
                      </Form.Control.Feedback>
                    )}
                  </Col>
                </Row>
                <div>
                  <p className="small text-muted">※ 施策期間の開始日は必須です。</p>
                </div>
              </Form.Group>
              <Form.Group className="mb-4">
                <Form.Label className="h5">
                  CSVインポート
                  <Badge bg="danger" className="ms-2">
                    必須
                  </Badge>
                  <OverlayTrigger
                    placement="bottom"
                    trigger={['hover', 'focus']}
                    overlay={
                      <BSTooltip id="info-tooltip">
                        csvのfreetext列は128文字以下で自由に記載いただけますが
                        <br />
                        個人情報の取り扱いには十分ご注意ください
                      </BSTooltip>
                    }
                  >
                    <img src="/manager/info-circle.svg" className="ms-2 mb-1" width="20px" />
                  </OverlayTrigger>
                </Form.Label>
                <Row>
                  <Col className="col-auto">
                    <Button
                      variant="link"
                      href="/manager/accuriodx_template.csv"
                      download="accuriodx_template.csv"
                      className="button-link ps-0 pe-0"
                    >
                      テンプレートファイルをダウンロードする
                    </Button>
                  </Col>
                </Row>
                <Form.Group className="custom-file" controlId="fileb">
                  <Form.Control
                    type="file"
                    placeholder=""
                    className="create-unit-hide"
                    isInvalid={!!errors.fileb}
                    {...register('fileb', { required: true })}
                  />
                  <Row>
                    <Col className="col-auto">
                      <Form.Label className="custom-file-label btn btn-outline-secondary">
                        ファイル選択
                      </Form.Label>
                    </Col>
                    <Col>
                      {chooseFileName && <Form.Control plaintext readOnly value={chooseFileName} />}
                    </Col>
                  </Row>
                  {errors.fileb && (
                    <Form.Control.Feedback type="invalid">
                      入力が必須の項目です
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              </Form.Group>
              <div className="text-center">
                <Button type="submit" variant="dark" disabled={!isDirty}>
                  {submitValue}
                </Button>
              </div>

              <div
                id="file-progress-area"
                className={isSubmit ? 'text-center d-block' : 'text-center d-none'}
              >
                <p className="mt-2 mb-0">インポート完了しました。</p>
                <Button variant="link" href={'./'} className="button-link fs-6">
                  施策一覧に戻る
                </Button>
              </div>
            </Form>
          </div>

          <div
            id="data-output-area"
            className={isSubmit ? 'text-center d-block' : 'text-center d-none'}
          >
            <div
              className="wrapper text-start create-unit-bg-zero"
            >
              <div className="wrapper create-unit-padding">
                <div className="h5">登録データ確認</div>
                <p className="create-unit-font-small">
                  登録済みのユーザーはこちらから確認いただけます。
                </p>
                <div className="text-end">
                  <QRCodeDownloadBtn unitId={unitId}></QRCodeDownloadBtn>
                  <CsvFileDownloadBtn unitId={unitId}></CsvFileDownloadBtn>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </main>
      <Footer />
    </div>
  );
}
